'use client';

import React from 'react';
import { Input, Separator, Switch } from '@yaradigitallabs/ahua-react';
import { useOutputMaterialContext } from '../context';

const Filters: React.FC = () => {
  const {
    searchQuery,
    setSearchQuery,
    showOnlyUnMatched,
    setShowOnlyUnMatched,
  } = useOutputMaterialContext();
  return (
    <div className="">
      <form className="grid grid-cols-1 md:grid-cols-3 gap-4 px-6 py-4">
        <Input
          label="Search"
          size="s"
          iconLeading="Search"
          value={searchQuery}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchQuery(e.target.value)
          }
        />
        <div className="col-span-2 flex justify-start items-center space-x-2 font-black">
          <Switch
            label="View only unmatched items"
            labelPosition="right"
            style={{ fontWeight: 600 }}
            onCheckedChange={setShowOnlyUnMatched}
            checked={showOnlyUnMatched}
          />
        </div>
      </form>
      <Separator />
    </div>
  );
};

export default Filters;
